/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserVerificationRequest {
    getFixupPrototypeFunction() { return UserVerificationRequest.fixupPrototype; }

    static newInstance(model: Partial<UserVerificationRequest>): UserVerificationRequest {
        let obj = Object.assign(new UserVerificationRequest(), model);
        UserVerificationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserVerificationRequest>): UserVerificationRequest {
        if (!model) return null;
        return UserVerificationRequest.newInstance(<UserVerificationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserVerificationRequest) {
        if (!obj) return;

        models.UserVerificationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserVerificationRequest): boolean {
        Object.setPrototypeOf(obj, UserVerificationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User email
     */
    email: string;

}
